import { render } from "./ArticlesGrid.vue?vue&type=template&id=3795905a&scoped=true"
import script from "./ArticlesGrid.vue?vue&type=script&lang=js"
export * from "./ArticlesGrid.vue?vue&type=script&lang=js"

import "./ArticlesGrid.vue?vue&type=style&index=0&id=3795905a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3795905a"]])

export default __exports__